import { fromByteArray } from 'base64-js';
export class Binary {
    constructor(data) {
        this.data = data;
    }
    // Convert our type to JSON.
    toJSONValue() {
        return {
            data: fromByteArray(this.data),
        };
    }
    // Unique type name.
    typeName() {
        return 'Binary';
    }
}
//# sourceMappingURL=binary.js.map